import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { CadastrarOficinaComponent } from './cadastrar-oficina/cadastrar-oficina.component';
import { OficinaRoutingModule } from './oficina-routing.module';
import { OficinaComponent } from './oficina.component';


import { MatDialogModule } from "@angular/material/dialog";
import { NgxCurrencyModule } from 'ngx-currency';
import { ComboBeneficiarioModule } from "../common/combo-beneficiario/combo-beneficiario.module";
import { ComboCargoModule } from "../common/combo-cargo/combo-cargo.module";
import { ComboContratoModule } from "../common/combo-contrato/combo-contrato.module";
import { ComboFuncionarioModule } from "../common/combo-funcionario/combo-funcionario.module";
import { ComboMaterialModule } from "../common/combo-material/combo-material.module";
import { ComboMetaAcaoModule } from "../common/combo-meta-acao/combo-meta-acao.module";
import { ComboMetaObjetivoModule } from "../common/combo-meta-objetivo/combo-meta-objetivo.module";
import { ComboObjetivoModule } from "../common/combo-objetivo/combo-objetivo.module";
import { ComboPercursoModule } from "../common/combo-percurso/combo-percurso.module";
import { ComboProgramaModule } from "../common/combo-programa/combo-programa.module";
import { ComboProjetoModule } from "../common/combo-projeto/combo-projeto.module";
import { ComboPublicoAlvoModule } from '../common/combo-publico-alvo/combo-publico-alvo.module';
import { DadosFuncionarioModule } from '../common/dados-funcionario/dados-funcionario.module';
import { AcoesOficinaComponent } from "./acoes-oficina/acoes-oficina.component";
import { CadastrarAcoesOficinaComponent } from "./acoes-oficina/cadastrar-acoes/cadastrar-acoes-oficina.component";
import { ListarAcoesOficinaComponent } from "./acoes-oficina/listar-acoes/listar-acoes-oficina.component";
import { CadastrarColaboradoresAtividadeComponent } from './colaboradores-atividade/cadastrar-colaboradores-atividade/cadastrar-colaboradores-atividade.component';
import { ColaboradoresAtividadeComponent } from './colaboradores-atividade/colaboradores-atividade.component';
import { ListarColaboradoresAtividadeComponent } from './colaboradores-atividade/listar-colaboradores-atividade/listar-colaboradores-atividade.component';
import { DadosAtividadeComponent } from './dados-atividade/dados-atividade.component';
import {
    FormularioAcoesExecutadaMetasComponent
} from "./formulario-acoes-executada-metas/formulario-acoes-executada-metas.component";
import {
    FormularioAcoesExecutadasColaboradorComponent
} from "./formulario-acoes-executadas-colaborador/formulario-acoes-executadas-colaborador.component";
import {
    FormularioAcoesExecutadasFrequenciaComponent
} from "./formulario-acoes-executadas-frequencia/formulario-acoes-executadas-frequencia.component";
import { FormularioAcoesExecutadasComponent } from "./formulario-acoes-executadas/formulario-acoes-executadas.component";
import { FormularioAcoesMetasComponent } from "./formulario-acoes-metas/formulario-acoes-metas.component";
import { FormularioObjetivoAtividadeComponent } from "./formulario-objetivo-atividade/formulario-objetivo-atividade.component";
import { CadastrarMateriaisComponent } from './materiais-oficina/cadastrar-materiais/cadastrar-materiais.component';
import { ListarMateriaisComponent } from './materiais-oficina/listar-materiais/listar-materiais.component';
import { MateriaisOficinaComponent } from './materiais-oficina/materiais-oficina.component';
import { CadastrarPublicoAlvoAtividadeComponent } from './publico-alvo-atividade/cadastrar-publico-alvo-atividade/cadastrar-publico-alvo-atividade.component';
import { ListarPublicosAlvoAtividadeComponent } from './publico-alvo-atividade/listar-publicos-alvos-atividades/listar-publico-alvo-atividade.component';
import { PublicoAlvoAtividadeComponent } from './publico-alvo-atividade/publico-alvo-atividade.component';


@NgModule({
  declarations: [OficinaComponent,
                 CadastrarOficinaComponent,
                 MateriaisOficinaComponent,
                 CadastrarMateriaisComponent,
                 ListarMateriaisComponent,
                 DadosAtividadeComponent,
                 ColaboradoresAtividadeComponent,
                 CadastrarColaboradoresAtividadeComponent,
                 ListarColaboradoresAtividadeComponent,
                 FormularioObjetivoAtividadeComponent,
                 AcoesOficinaComponent,
                 CadastrarAcoesOficinaComponent,
                 ListarAcoesOficinaComponent,
                 PublicoAlvoAtividadeComponent,
                 CadastrarPublicoAlvoAtividadeComponent,
                 ListarPublicosAlvoAtividadeComponent,
                 FormularioAcoesExecutadasComponent,
                 FormularioAcoesExecutadasFrequenciaComponent,
                 FormularioAcoesExecutadasColaboradorComponent,
                 FormularioAcoesMetasComponent,
                 FormularioAcoesExecutadaMetasComponent],
    imports: [
        CommonModule,
        OficinaRoutingModule,
        MaterialCommonModule,
        MatExpansionModule,
        MatTabsModule,
        NgxCurrencyModule,
        DadosFuncionarioModule,
        ComboContratoModule,
        ComboPercursoModule,
        MatDialogModule,
        ComboFuncionarioModule,
        ComboBeneficiarioModule,
        ComboMetaObjetivoModule,
        ComboMetaAcaoModule,
        ComboProjetoModule,
        ComboProgramaModule,
        ComboMaterialModule,
        ComboCargoModule,
        ComboObjetivoModule,
        ComboPublicoAlvoModule
    ]
})
export class OficinaModule { }
